module.exports = __webpack_public_path__ + "img/17.7.Chla.7c95f127.png";